window.config = {
  webPath: "",

  itradeAPI: location.origin,
  itradePath: "api",

  mdsInfo: {
    MDSStreamingAPI: "",
    MDSSnapshotAPI: "wss://ttl2aacloud01.tx-tech.com/snapshot/pubsub",
    MDSOthersAPI: "wss://ttl2aacloud01.tx-tech.com/info/pubsub",
    MDSProxyAPI: "ws://10.98.30.107:9996/pubsub",
    MDSEntityKey: "EIF",
    MDSSuperkey: "eifhk2txtech1keyencrypt20key0729",
  },

  winvestorAPI: location.origin,
  winvestorPath: "eif/api",

  winvestorDeviceID: "itrade7.5-web-eif",

  // en_US 英 zh_CN 简 zh_TW 繁
  defaultLanguage: "zh_CN",

  // Portfolio refresh after Para change
  portfolioRefreshAfterParaChangeMs: 2000,
  portfolioRefreshAfterParaChangeAttempts: 1,

  companyOptions: {
    disclaimer: {
      zh_CN:
        "https://mdas.tx-tech.com/eif/web/zh-hans/basic_page/disclaimer.html",
      en_US: "https://mdas.tx-tech.com/eif/web/en/basic_page/disclaimer.html",
      zh_TW:
        "https://mdas.tx-tech.com/eif/web/zh-hant/basic_page/disclaimer.html",
    },
    trading: {
      autoRefreshOrderEnquiry: 5000,
      autoCheckSession: 300000,
      refreshSession: false,
    },
    bcan: {
      zh_CN: "https://www.eif.com.hk/zh/faq/forms",
      en_US: "https://www.eif.com.hk/en/faq/forms",
      zh_TW: "https://www.eif.com.hk/zh/faq/forms",
    },
  },

  popupIPRestrictedMsg: false
};
